export default (axios, baseURL) => async () => {
  const url = `/v2/clients/generate-secret-key`;

  const axiosConfig = {
    method: 'GET',
    baseURL,
    url
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
